import HomeReporting from "@/views/service_provider/tech_visits/reporting/HomeReporting.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "sp",
  role: "tech_visits",
  permission: "reporting",
});

export default [
  {
    path: "/service_provider/:service_provider_id/tech_visits/reporting",
    name: routeName(""),
    component: HomeReporting,
    props: true,
    meta: META
  },
];
